import React from 'react';
import { Redirect, Route, Switch, useRouteMatch } from 'react-router-dom';
import usePage from '@dashboard/hooks/usePage';
import { useAuth } from '@dashboard/context/AuthContext/AuthContext';
import ManageStaffPanel from './components/ManageStaffPanel';

const EventStaff: React.FC = () => {
  const match = useRouteMatch();
  const { page } = usePage();
  const { isOwner, userRoleInSeller } = useAuth();
  const pageId = page?._id ?? '';
  const sellerId = page?.seller?._id ?? '';
  const canManage = isOwner || userRoleInSeller === 'admin';

  return (
    <Switch>
      <Route path={`${match.url}/manage`} exact>
        <ManageStaffPanel pageId={pageId} sellerId={sellerId} canManage={canManage} />
      </Route>
      <Redirect to={`${match.url}/manage`} />
    </Switch>
  );
};

export default EventStaff;
